// extracted by mini-css-extract-plugin
export default {"formGrid":"businessPanel_formGrid__5otIZ"};